var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-drawer",
    {
      staticStyle: {
        height: "100%",
        overflow: "auto",
        "padding-bottom": "53px"
      },
      attrs: {
        title: _vm.title,
        maskClosable: false,
        width: _vm.drawerWidth,
        placement: "right",
        closable: true,
        "ok-disabled": _vm.disableSubmit,
        visible: _vm.visible
      },
      on: { close: _vm.handleCancel }
    },
    [
      _c("template", { slot: "title" }, [
        _c("div", { staticStyle: { width: "100%" } }, [
          _c("span", [_vm._v(_vm._s(_vm.title))]),
          _c(
            "span",
            {
              staticStyle: {
                display: "inline-block",
                width: "calc(100% - 51px)",
                "padding-right": "10px",
                "text-align": "right"
              }
            },
            [
              _c("a-button", {
                staticStyle: { height: "20px", width: "20px", border: "0px" },
                attrs: { icon: "appstore" },
                on: { click: _vm.toggleScreen }
              })
            ],
            1
          )
        ])
      ]),
      _c(
        "a-spin",
        { attrs: { spinning: _vm.confirmLoading } },
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: { model: _vm.model, rules: _vm.validatorRules }
            },
            [
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: "用户账号",
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "username"
                  }
                },
                [
                  _c("a-input", {
                    attrs: {
                      placeholder: "请输入用户账号",
                      disabled: !!_vm.model.id,
                      maxLength: _vm.maxLength
                    },
                    model: {
                      value: _vm.model.username,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "username", $$v)
                      },
                      expression: "model.username"
                    }
                  })
                ],
                1
              ),
              !_vm.model.id
                ? [
                    _c(
                      "a-form-model-item",
                      {
                        attrs: {
                          label: "登录密码",
                          labelCol: _vm.labelCol,
                          wrapperCol: _vm.wrapperCol,
                          prop: "password"
                        }
                      },
                      [
                        _c("a-input-password", {
                          attrs: {
                            type: "password",
                            placeholder: "请输入登录密码",
                            maxLength: _vm.maxLength,
                            disabled: _vm.disableSubmit
                          },
                          model: {
                            value: _vm.model.password,
                            callback: function($$v) {
                              _vm.$set(_vm.model, "password", $$v)
                            },
                            expression: "model.password"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "a-form-model-item",
                      {
                        attrs: {
                          label: "确认密码",
                          labelCol: _vm.labelCol,
                          wrapperCol: _vm.wrapperCol,
                          prop: "confirmpassword",
                          disabled: _vm.disableSubmit
                        }
                      },
                      [
                        _c("a-input-password", {
                          attrs: {
                            type: "password",
                            placeholder: "请重新输入登录密码",
                            maxLength: _vm.maxLength,
                            disabled: _vm.disableSubmit
                          },
                          on: { blur: _vm.handleConfirmBlur },
                          model: {
                            value: _vm.model.confirmpassword,
                            callback: function($$v) {
                              _vm.$set(_vm.model, "confirmpassword", $$v)
                            },
                            expression: "model.confirmpassword"
                          }
                        })
                      ],
                      1
                    )
                  ]
                : _vm._e(),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: "用户姓名",
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "realname"
                  }
                },
                [
                  _c("a-input", {
                    attrs: {
                      placeholder: "请输入用户姓名",
                      maxLength: _vm.maxLength,
                      disabled: _vm.disableSubmit
                    },
                    model: {
                      value: _vm.model.realname,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "realname", $$v)
                      },
                      expression: "model.realname"
                    }
                  })
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: "用户类型",
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "userType"
                  }
                },
                [
                  _c("j-dict-select-tag", {
                    attrs: {
                      type: "radio",
                      "trigger-change": true,
                      dictCode: "user_type_emp",
                      disabled: _vm.disableSubmit
                    },
                    model: {
                      value: _vm.model.userType,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "userType", $$v)
                      },
                      expression: "model.userType"
                    }
                  })
                ],
                1
              ),
              !(_vm.model.userType === "nonemployee")
                ? _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        label: "工号",
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        prop: "workNo"
                      }
                    },
                    [
                      _c("a-input", {
                        attrs: {
                          placeholder: "请输入工号",
                          maxLength: _vm.maxLength,
                          disabled: _vm.disableSubmit
                        },
                        model: {
                          value: _vm.model.workNo,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "workNo", $$v)
                          },
                          expression: "model.workNo"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: "邮箱",
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "email"
                  }
                },
                [
                  _c("a-input", {
                    attrs: {
                      placeholder: "请输入邮箱",
                      maxLength: 50,
                      disabled: _vm.disableSubmit
                    },
                    model: {
                      value: _vm.model.email,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "email", $$v)
                      },
                      expression: "model.email"
                    }
                  })
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: "手机号码",
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "phone"
                  }
                },
                [
                  _c("a-input", {
                    attrs: {
                      placeholder: "请输入手机号码",
                      maxLength: _vm.maxLength,
                      disabled: _vm.disableSubmit
                    },
                    model: {
                      value: _vm.model.phone,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "phone", $$v)
                      },
                      expression: "model.phone"
                    }
                  })
                ],
                1
              ),
              _vm.roleLoading
                ? _c(
                    "a-form-model-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.roleDisabled,
                          expression: "!roleDisabled"
                        }
                      ],
                      attrs: {
                        label: "角色分配",
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol
                      }
                    },
                    [
                      _c("j-select-role-for-apllication", {
                        attrs: {
                          disabled: _vm.disableSubmit,
                          appId: _vm.apps ? _vm.apps.join(",") : "",
                          option: _vm.rolesOptions,
                          listUrl: _vm.roleListUrl
                        },
                        model: {
                          value: _vm.model.selectedroles,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "selectedroles", $$v)
                          },
                          expression: "model.selectedroles"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c("a-col", {
                staticStyle: { height: "50px" },
                attrs: { span: 24 }
              })
            ],
            2
          )
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.disableSubmit,
              expression: "!disableSubmit"
            }
          ],
          staticClass: "drawer-bootom-button"
        },
        [
          _c(
            "a-popconfirm",
            {
              attrs: {
                title: "确定放弃编辑？",
                okText: "确定",
                cancelText: "取消"
              },
              on: { confirm: _vm.handleCancel }
            },
            [
              _c("a-button", { staticStyle: { "margin-right": ".8rem" } }, [
                _vm._v("取消")
              ])
            ],
            1
          ),
          _c(
            "a-button",
            {
              attrs: { type: "primary", loading: _vm.confirmLoading },
              on: { click: _vm.handleSubmit }
            },
            [_vm._v("提交")]
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }